export default (params) => {
  const {
    page, sort, sortDirection, ...filters
  } = params;
  const queryParts = Object.keys(filters)
    .filter((key) => filters[key] !== undefined && filters[key] !== null)
    .map((key) => `filters[${key}]=${filters[key]}`);

  if (sort && sortDirection) {
    queryParts.push(`sort[${sort}]=${sortDirection}`);
  }

  if (page) {
    queryParts.push(`page=${page}`);
  }

  return `?${queryParts.join('&')}`;
};
